<div class="label-container" [class.only-icon]="onlyIcon">
    <svg-icon *ngIf="icon" class="label-icon" [src]="icon"></svg-icon>
    <p *ngIf="!onlyIcon" class="label-text">{{ text }}</p>
</div>